import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { sellerStripePaymentMethodConfigurationsKey } from '@dashboard/lib/queryKeys';
import getStripePaymentMethodConfigurations from '@dashboard/services/seller/getStripePaymentMethodConfigurations';

const FIVE_MINUTES = 5 * 60 * 1000;

export default function useStripePaymentMethodConfigurations({ sellerId, enabled = true } = {}) {
  const { token } = useAuth();

  return useQuery({
    queryKey: sellerStripePaymentMethodConfigurationsKey(sellerId),
    queryFn: () => getStripePaymentMethodConfigurations({ sellerId, token }),
    enabled: Boolean(sellerId) && enabled,
    staleTime: FIVE_MINUTES,
  });
}
